import { useRef } from 'react';

import { usePreventScrollOnWheel } from '../../hooks/usePreventScrollOnWheel.js';

export const WheelZoomPreventer = () => {
  const ref = useRef<HTMLDivElement>(null);

  usePreventScrollOnWheel(ref);

  return (
    <div
      ref={ref}
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    />
  );
};

WheelZoomPreventer['displayName'] = 'WheelZoomPreventer';
